import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),

    routes: [
        { 
            name: 'BirdView',         
            path: '/art/:id',               
            component: () => import(/* webpackChunkName: "cnk-BirdView" */ "@/views/BirdView.vue"),
            meta: { requiresAuth: false }
        },
        { 
            name: 'Home',             
            path: '/',                      
            component: () => import(/* webpackChunkName: "cnk-Home" */ "@/views/HomeView.vue"),
            meta: { requiresAuth: false }              
        },

        { 
            name: 'AdminHome',        
            path: '/admin',                 
            component: () => import(/* webpackChunkName: "adminHome" */ '@/views/admin/AdminHome.vue'),
            meta: { requiresAuth: true }
        },
        { 
            name: 'Login',            
            path: '/admin/login',           
            component: () => import(/* webpackChunkName: "adminLogin" */ '@/views/admin/Login.vue'),
            meta: { requiresAuth: false }          
        },
        { 
            name: 'EditBirdText',     
            path: '/admin/edit/texts/:id',  
            component: () => import(/* webpackChunkName: "adminEditBird" */ '@/views/admin/EditBirdText.vue'),
            meta: { requiresAuth: true }  
        },
        { 
            name: 'EditBirdFacts',    
            path: '/admin/edit/facts/:id',  
            component: () => import(/* webpackChunkName: "adminEditBird" */ '@/views/admin/EditBirdFacts.vue'),
            meta: { requiresAuth: true } 
        }        
    ],
    scrollBehavior() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'instant',
        });
    }
})

router.beforeEach((to, from, next) => {

    let isAuthenticated = JSON.parse(window.localStorage.getItem("access_token"))
    
    if (to.meta.requiresAuth && !isAuthenticated) {
        next({ name: 'Login' });
    }
    else {
        next();
    }
});

export default router; 